export default __webpack_public_path__ + "static/media/bw.9609a72f.svg";